module.exports = __webpack_public_path__ + "static/media/0.8335cd4d.jpg";